/**
 * QueueItem - Single document entry in the validation queue.
 */
import { QueueItemProps } from './types';

export function QueueItem({ document, isSelected, onClick }: QueueItemProps) {
  return (
    <button
      onClick={onClick}
      className={`
        w-full p-4 text-left transition-colors border-b border-line
        ${isSelected
          ? 'bg-info-soft border-l-4 border-l-blue-500'
          : 'hover:bg-surface-2 border-l-4 border-l-transparent'
        }
      `}
    >
      <div className="flex items-start gap-3">
        {/* User avatar */}
        <div className="w-10 h-10 rounded-full bg-surface-3 flex items-center justify-center flex-shrink-0">
          <span className="font-medium text-ink-2">
            {document.user_name.split(' ').map((n) => n[0]).join('').slice(0, 2)}
          </span>
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <p className="font-medium text-ink truncate">{document.user_name}</p>
          <p className="text-sm text-ink-2">{document.document_type}</p>
          <div className="flex items-center gap-2 mt-1">
            {document.is_blocking && (
              <span className="px-2 py-0.5 text-xs bg-danger-soft text-danger rounded">
                Bloqueante
              </span>
            )}
            <span className="text-xs text-ink-3">
              {new Date(document.created_at).toLocaleDateString('es-ES')}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
}
